import React from 'react';
import "../App.css";
import { useNavigate } from 'react-router-dom';
function Sidebar() {
  const navigate = useNavigate();

  const handleNavigation1 = () => {
    navigate('/CreateAudit');

  };
  const handleNavigation2 = () => {
    navigate('/view-audit');

  };
  return (
    <div className="sidebar">
      <div className="sidebar-header">Surveyor's A</div>
      <ul className="sidebar-menu">
      <li onClick={handleNavigation1}>
        <a >
          <i className="sidebar-icon"></i>Create Audit
        </a>
      </li>
        <li onClick={handleNavigation2}>
        <a >
          <i className="sidebar-icon"></i>View Audit
        </a>
      </li>
      </ul>
    </div>
  );
}

export default Sidebar;
